
import { toString, Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, array_type, bool_type, int32_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { StringBuilder__Append_Z721C83C5, StringBuilder_$ctor } from "../fable_modules/fable-library-js.5.3.0/System.Text.js";
import { initialize, item } from "../fable_modules/fable-library-js.5.3.0/Array.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { generate as generate_1, correction } from "lean-qr";

/**
 * Square module grid; IsDark[y][x] is true for a dark module.
 */
export class QrMatrix extends Record {
    constructor(Size, IsDark) {
        super();
        this.Size = (Size | 0);
        this.IsDark = IsDark;
    }
}

export function QrMatrix_$reflection() {
    return record_type("Shared.QrCode.QrMatrix", [], QrMatrix, () => [["Size", int32_type], ["IsDark", array_type(array_type(bool_type))]]);
}

export const quietZone = 4;

/**
 * Side of the SVG viewBox in modules, quiet zone included.
 */
export function viewBoxSize(m) {
    return (m.Size + (2 * quietZone)) | 0;
}

/**
 * One 1x1 square per dark module, offset by the quiet zone; empty when no module is dark.
 */
export function svgPath(m) {
    const sb = StringBuilder_$ctor();
    for (let y = 0; y <= (m.Size - 1); y++) {
        for (let x = 0; x <= (m.Size - 1); x++) {
            if (item(x, item(y, m.IsDark))) {
                StringBuilder__Append_Z721C83C5(sb, `M${x + quietZone} ${y + quietZone}h1v1h-1z`);
            }
        }
    }
    return toString(sb);
}

/**
 * Encodes `text` at error-correction level M; Error when lean-qr throws (e.g. input too long).
 */
export function generate(text) {
    try {
        const level = correction.M;
        const bitmap = generate_1(text, {
            minCorrectionLevel: level,
            maxCorrectionLevel: level,
        });
        const size = bitmap.size | 0;
        return new FSharpResult$2(0, [new QrMatrix(size, initialize(size, (y) => initialize(size, (x) => (bitmap.get(x, y)))))]);
    }
    catch (ex) {
        return new FSharpResult$2(1, [ex]);
    }
}

//# sourceMappingURL=QrCode.js.map
